<template>
<div class="chapter">
<div class="inner_page">
<p class="figure"><a id="pl-3-3"></a><img alt="image" height="401" src="images/image03-00.jpg" width="299"/></p>
<p class="pub">compiled and edited by Sara Bader</p>
<p class="pub1">Princeton Architectural Press, New York</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_booktitle.vue?dc91eeec